import { buildProps, definePropType } from '@code-monkey-ui/utils'
import { panelSharedProps } from './shared'

import type { ExtractPropTypes } from 'vue'
import type { Dayjs } from 'dayjs'

export const panelWeekPickProps = buildProps({
  ...panelSharedProps,
  parsedValue: {
    type: definePropType<Dayjs | Dayjs[]>([Object, Array]),
  },
  weekStart: {
    type: Number,
    required: true,
  },
  visible: {
    type: Boolean,
  },
  format: {
    type: String,
    default: '',
  },
} as const)

export type PanelWeekPickProps = ExtractPropTypes<typeof panelWeekPickProps>
